import styled from 'styled-components';
import { theme } from '../../theme/semanticTokens';
import { IconSize } from '../../types/icons/Icon.types';

// The Figma frame reports the *total* content-box width (200px) including its
// own horizontal padding. Padding lives on `.ant-popover-inner` (see
// `POPOVER_INNER_STYLE` in Popover.tsx), so the inner content wrapper only
// needs the remaining width: 200 - (Spacing/L * 2) = 168.
const CONTENT_WIDTH = '168px';

export const PopoverContent = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: ${theme.dime.spacing.m};
  width: ${CONTENT_WIDTH};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.dime.spacing.m};
  width: 100%;
`;

export const TitleText = styled.p`
  flex: 1 0 0;
  min-width: 0;
  margin: 0;
  font-family: ${theme.dime.fonts.families.roboto};
  font-size: ${theme.dime.fonts.sizes.sm};
  font-weight: ${theme.dime.fonts.weights.semiBold};
  line-height: ${theme.dime.fonts.lineHeights.md};
  color: ${theme.dime.colors.text.primary};
  word-break: break-word;
`;

export const BodyText = styled.p`
  width: 100%;
  margin: 0;
  font-family: ${theme.dime.fonts.families.roboto};
  font-size: ${theme.dime.fonts.sizes.sm};
  font-weight: ${theme.dime.fonts.weights.regular};
  line-height: ${theme.dime.fonts.lineHeights.md};
  color: ${theme.dime.colors.text.primary};
  word-break: break-word;
`;

export const CloseIconButton = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: ${IconSize.Small};
  height: ${IconSize.Small};
  padding: 0;
  border: none;
  background: none;
  color: ${theme.dime.colors.icon.primary};
  cursor: pointer;
`;

export const SlotContent = styled.div`
  width: 100%;
`;
